<template>
  <div class="bd-content p-4">
    <template v-if="!staticContent.content">
      <content-loader
        :width="1000"
        :height="63"
        :speed="2"
        primaryColor="#f4f5fa"
        secondaryColor="#eee"
        class="loading-bg"
        v-for="(item, index) in 5"
        :key="'loading-' + index"
      >
        <rect x="0" y="0" rx="6" ry="6" width="1000" height="83" />
      </content-loader>
    </template>
    <h3 class="h3">{{ staticContent.title }}</h3>
    <p v-for="(item, index) in staticContent.content" :key="'content-' + index" v-html="item"></p>
    <!-- <div class="primeTrustWrapper">
      <div class="primeTrustText">Financial infrastructure APIs and widgets by</div>
      <img v-if="staticContent.content" src="../../assets/images/logo/prime-trust-logo.png" alt="" />
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'Information',
  components: {
    ContentLoader
  },
  computed: {
    ...mapState({
      selectedCurrency: (state) => state.withdrawal.selectedCurrency,
      staticContent: (state) => state.withdrawal.infoContent,
    })
  },
};
</script>
